import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setInnerStepper } from "../../../redux/slices/common_slice";
import { routePaths } from "../../../routing/routePaths";
import { isPWA } from "../../../utils/helper";

const Splash = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stepperStatus = useSelector((state) => state.common?.stepperStatus);

  useEffect(() => {
    if (isPWA() && Object.keys(stepperStatus)?.length > 0) {
      handleRouting(stepperStatus);
    } else {
      const timerID = setTimeout(() => {
        navigate(routePaths.selectLanguage);
      }, 4000);
      return () => {
        clearTimeout(timerID);
      };
    }
  }, [stepperStatus]);

  const handleRouting = (statusData) => {
    if (statusData.isExpenseCompleted) {
      navigate("/dashboard");
    } else if (statusData?.isIncomeCompleted) {
      navigate(routePaths.expenses);
      dispatch(setInnerStepper(statusData?.expenseStep || 0));
    } else if (statusData?.isProfileCompleted) {
      navigate(routePaths.income);
      dispatch(setInnerStepper(statusData?.incomeStep || 0));
    } else if (statusData?.profileStep) {
      navigate(routePaths.onboarding);
      dispatch(setInnerStepper(statusData?.profileStep || 0));
    } else {
      navigate(routePaths.getStarted);
    }
  };
  return (
    <div className="splash-main d-flex align-items-center w-100 justify-content-center">
      <img
        src="/assets/images/butterfly-logo.svg"
        alt="app logo"
        className="img-fluid"
        width={300}
      />
    </div>
  );
};

export default Splash;
